module.exports = __webpack_public_path__ + "Smart-eab4ca5f25db089597fd833e94c03ab7.png";